import React from 'react'
import "./ChatHeader.css"
import NotificationsIcon from '@material-ui/icons/Notifications';
import EditLocationRoundedIcon from '@material-ui/icons/EditLocationRounded';
import PeopleAltRoundedIcon from '@material-ui/icons/PeopleAltRounded';
import SearchRoundedIcon from '@material-ui/icons/SearchRounded';
import SendOutlinedIcon from '@material-ui/icons/SendOutlined';
import HelpRoundedIcon from '@material-ui/icons/HelpRounded';

function ChatHeader({channelName}) {
    return (
        <div className="chat_header">
            <div className="chat_headerLeft">
<h3><span className="chat_headerHash">#</span>{channelName}</h3>
            </div>
            <div className="chat_headerRight">
<NotificationsIcon/>
<EditLocationRoundedIcon />
<PeopleAltRoundedIcon/>
<div className="chatHeader_search">
    <input type="text" placeholder="Search"/>
    <SearchRoundedIcon/>
</div>
<SendOutlinedIcon/>
<HelpRoundedIcon/>
            </div>
        </div>
    )
}

export default ChatHeader
